import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./StationSettings.module.css";
import { checkToken } from "../../Utils/TokenService";
import { useNavigate } from "react-router-dom";
import config from "../../../settings/config";
import { toast } from "react-toastify";
import CustomModal from "../../Utils/CustomModal";
import classNames from "classnames";
import Header from "../../Utils/Header/Header";
import localeRu from "../../../locales/ru/stations/stationSettings.json";
import localeEn from "../../../locales/en/stations/stationSettings.json";
import TimezoneSelect from "react-timezone-select";
import useAuthToken from "../../../hooks/useAuthToken";
import useStateBackend from "../../../hooks/useStateBackend";

const StationSettings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [station, setStation] = useState(location.state?.station);
  const [stationName, setStationName] = useState(
    location.state?.station?.nickName,
  );
  const [stationPower, setStationPower] = useState(
    location.state?.station?.powerCp,
  );
  const [showModal, setShowModal] = useState(false);
  const [maxPower, setMaxPower] = useState(
    Number(location.state?.station?.powerCp) <
      Number(location.state?.station?.maxPower)
      ? location.state?.station?.powerCp
      : location.state?.station?.maxPower,
  );
  const [autoCharge, setAutoCharge] = useState(
    location.state?.station?.autoCharge || false,
  );
  const [outerCounter, setOuterCounter] = useState(
    location.state?.station?.stationSettings.outerCounter || false,
  );
  const [isNotification, setIsNotification] = useState(
    location.state?.station?.stationSettings.isNotification || false,
  );
  const [selectedTimezone, setSelectedTimezone] = useState(
    location.state?.station?.timeZone ||
      Intl.DateTimeFormat().resolvedOptions().timeZone,
  );
  let lang = localStorage.getItem("language") === "ru";

  const changeScale = (maxPower) => {
    return (maxPower - 1) / 4;
  };

  const getStyleButton = (status) => {
    if (status) {
      return styles.autoChargeSettingOn;
    } else {
      return styles.autoChargeSetting;
    }
  };

  const scaleStep = changeScale(stationPower);
  // const station = location.state?.station;  // Получаем объект станции из state
  const slaveId = 1;
  const [stationUpdate, setStationUpdate] = useState(
    station?.connectors[0]?.update,
  );
  const stepsCount = Math.ceil((stationPower - 1) / scaleStep) + 1;
  const safeStepsCount =
    Number.isFinite(stepsCount) && stepsCount > 0 ? stepsCount : 0;

  const token = useAuthToken();
  useStateBackend();

  async function requestSettings() {
    try {
      // Создаем объект с данными для отправки
      const requestBody = {
        sn: station.sn,
        nickName: stationName,
        maxPower: maxPower,
        slaveId: slaveId,
        autoCharge: autoCharge,
        outerCounter: outerCounter,
        isNotification: isNotification,
        timeZone: selectedTimezone?.value || location.state?.station.timeZone,
      };

      const response = await fetch(
        `${config.app.host}/api/v1/station/settings/edit`,
        {
          method: "POST", // Используем метод POST
          headers: {
            "Content-Type": "application/json", // Указываем, что отправляем JSON
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody), // Преобразуем объект в JSON
        },
      );

      const responseData = await response.json();

      if (!response.ok) {
        toast.error(lang ? localeRu.unknownError : localeEn.unknownError, {
          position: "top-center",
          autoClose: 3000,
          style: { color: "white", backgroundColor: "black" },
        });
      }
      toast.success(
        lang ? localeRu.stationSettingsSaved : localeEn.stationSettingsSaved,
        {
          position: "top-center",
          autoClose: 3000,
          style: { color: "white", backgroundColor: "black" },
        },
      );
    } catch (error) {
      // console.error('Ошибка при отправке запроса:', error);
    }
    navigate(-1);
  }

  const confirmDeleteStation = async () => {
    // Выполняем логику выхода, например, очищаем токены и перенаправляем на страницу входа
    let resp = "";
    if (token) {
      try {
        const response = await fetch(
          `${config.app.host}/api/v1/station/delete?sn=${station.sn}`,
          {
            method: "GET",
            mode: "cors",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          // throw new Error('Network response was not ok');
          if (lang) {
            toast.error(`${localeRu.networkError}`, {
              position: "top-center",
              autoClose: 3000,
              style: { color: "white", backgroundColor: "black" },
            });
          } else {
            toast.error(`${localeEn.networkError}`, {
              position: "top-center",
              autoClose: 3000,
              style: { color: "white", backgroundColor: "black" },
            });
          }
        }

        resp = await response.json();
        if (resp.error) {
          navigate("/myStations"); // Перенаправляем на страницу входа
        }
      } catch (error) {
        navigate("/myStations"); // Перенаправляем на страницу входа
      }
      toast.success(
        (lang ? localeRu.stationDeleted : localeEn.stationDeleted).replace(
          "{nickName}",
          station.nickName,
        ),
        {
          position: "top-center",
          autoClose: 3000,
          style: { color: "white", backgroundColor: "black" },
        },
      );
    }
    navigate("/myStations"); // Перенаправляем на страницу входа
  };

  const updateStation = async () => {
    // Выполняем логику выхода, например, очищаем токены и перенаправляем на страницу входа
    let resp = "";

    if (token) {
      try {
        const response = await fetch(
          `${config.app.host}/api/v1/station/update?sn=${station.sn}&slaveId=${slaveId}`,
          {
            method: "GET",
            mode: "cors",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          // throw new Error('Network response was not ok');
          if (lang) {
            toast.error(`${localeRu.networkError}`, {
              position: "top-center",
              autoClose: 3000,
              style: { color: "white", backgroundColor: "black" },
            });
          } else {
            toast.error(`${localeEn.networkError}`, {
              position: "top-center",
              autoClose: 3000,
              style: { color: "white", backgroundColor: "black" },
            });
          }
        }
        resp = await response.json();

        setStationUpdate(resp.result);
      } catch (error) {}
      toast.success(lang ? localeRu.startUpdate : localeEn.startUpdate, {
        position: "top-center",
        autoClose: 3000,
        style: { color: "white", backgroundColor: "black" },
      });
    }
  };

  const handleChangeAutoCharge = () => {
    setAutoCharge(!autoCharge);
  };

  const handleChangeInnerCounter = () => {
    setOuterCounter(!outerCounter);
  };

  const handleChangeIsNotification = () => {
    setIsNotification(!isNotification);
  };

  const handleSettings = () => {
    requestSettings();
  };

  const handleUpdate = () => {
    updateStation();
  };

  const handleLogOut = () => {
    setShowModal(true);
  };

  const handleShare = () => {
    navigate("/stationShare", { state: { station } });
  };

  const handleSchedule = () => {
    navigate("/stationSchedule", { state: { station } });
  };

  return (
    <div className={styles.container}>
      <Header
        title={lang ? localeRu.titleName : localeEn.titleName}
        back={true}
        station={station}
      />

      <div className={styles.mainSection}>
        <div className={styles.parameter}>
          <p className={styles.paramText}>
            {lang ? localeRu.stationNameLabel : localeEn.stationNameLabel}
          </p>
        </div>
        <input
          type="text"
          className={styles.card}
          value={stationName}
          placeholder={
            lang
              ? localeRu.stationNamePlaceholder
              : localeEn.stationNamePlaceholder
          }
          maxLength={20}
          onChange={(e) => {
            if (e.target.value.length <= 20) {
              setStationName(e.target.value);
            }
          }}
        />
        <div className={styles.parameter}>
          <p className={styles.paramText}>
            {lang ? localeRu.maxPowerLabel : localeEn.maxPowerLabel}
          </p>
          <p className={styles.textMaxPower}>
            {maxPower}{" "}
            <span className={styles.unitGray}> {lang ? "кВт" : "kW"}</span>
          </p>
        </div>
        <div className={styles.maxPowerContainer}>
          <div className={styles.sliderContainer}>
            <input
              type="range"
              min="1"
              max={stationPower}
              step="0.1"
              value={maxPower}
              onChange={(e) => setMaxPower(parseFloat(e.target.value))}
              className={styles.slider}
            />
            <div className={styles.scale}>
              {[...Array(safeStepsCount)]?.map((_, index) => {
                const value = (index * scaleStep + 1).toFixed(1); // Начинаем с 1, сохраняем дробные значения
                if (parseFloat(value) > stationPower) return null; // Не добавляем деления выше максимальной мощности
                return (
                  <div key={value} className={styles.scaleMark}>
                    <span className={styles.scaleLabel}>{value}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {!station?.chargingHub && (
          <div>
            <div className={styles.autochargeContainer}>
              <p className={styles.textAutoCharge}>
                {lang ? localeRu.autoChargeLabel : localeEn.autoChargeLabel}
              </p>
              <div
                class={classNames(
                  styles.autoChargeSetting,
                  getStyleButton(autoCharge),
                )}
                onClick={handleChangeAutoCharge}
              >
                <div className={styles.autoChargeSettingElement}></div>
              </div>
            </div>
            {/* <div className={styles.autochargeContainer}>
                            <p className={styles.textAutoCharge}>{lang ? localeRu.notificationLabel : localeEn.notificationLabel}</p>
                            <div
                                class={classNames(styles.autoChargeSetting, getStyleButton(isNotification))}

                                onClick={handleChangeIsNotification}
                            >
                                <div className={styles.autoChargeSettingElement}></div>
                            </div>
            </div> */}
          </div>
        )}
        <div className={styles.parameter}>
          <p className={styles.paramText}>
            {lang ? localeRu.timeZone : localeEn.timeZone}
          </p>
        </div>
        <div className={styles.parameter}></div>
        <TimezoneSelect
          value={selectedTimezone}
          isSearchable={false}
          onChange={setSelectedTimezone}
          styles={{
            control: (provided) => ({
              ...provided,
              background: `
                                    linear-gradient(174deg, #1C2326 38.89%, #87C8E0 167.15%),
                                    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))
                                `,
              color: "#ffffff",
              borderRadius: "8px",
              border: "none",
              minHeight: "40px",
              boxShadow: "none",
            }),
            singleValue: (provided) => ({
              ...provided,
              color: "#ffffff",
            }),
            menu: (provided) => ({
              ...provided,
              backgroundColor: "#101111",
              color: "#ffffff",
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isFocused ? "#446470" : "#101111",
              color: "#ffffff",
              cursor: "pointer",
            }),
            input: (provided) => ({
              ...provided,
              color: "#ffffff",
            }),
            placeholder: (provided) => ({
              ...provided,
              color: "#cccccc",
            }),
          }}
        />
        <p>
          {lang ? localeRu.selectedTimeZone : localeEn.selectedTimeZone}{" "}
          {typeof selectedTimezone === "object"
            ? selectedTimezone.value
            : selectedTimezone}
        </p>
        {stationUpdate === "updateReady" && (
          <button
            type="button"
            onClick={handleUpdate}
            className={styles.submitUpdate}
          >
            <p className={styles.textButtons}>
              {lang ? localeRu.updateButton : localeEn.updateButton}
            </p>
          </button>
        )}
        {stationUpdate === "updateInProgress" && (
          <button type="button" className={styles.buttonLoading}>
            <p className={styles.textButtons}>
              {lang ? localeRu.loadingButton : localeEn.loadingButton}
            </p>
          </button>
        )}
      </div>
      <div className={styles.sectionButtons}>
        <button
          type="button"
          onClick={handleSettings}
          className={styles.submitStartCharging}
        >
          <p className={styles.textButtons}>
            {lang ? localeRu.saveButton : localeEn.saveButton}
          </p>
        </button>
        <button
          type="button"
          onClick={handleShare}
          className={styles.submitStartCharging}
        >
          <p className={styles.textButtons}>
            {lang ? localeRu.shareButton : localeEn.shareButton}
          </p>
        </button>
        <button
          type="button"
          onClick={handleSchedule}
          className={styles.submitStartCharging}
        >
          <p className={styles.textButtons}>
            {lang ? localeRu.schedule : localeEn.schedule}
          </p>
        </button>
        <button
          type="button"
          onClick={handleLogOut}
          className={styles.submitDelete}
        >
          <p className={styles.textButtons}>
            {lang ? localeRu.deleteButton : localeEn.deleteButton}
          </p>
        </button>
      </div>
      <CustomModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={confirmDeleteStation}
        textMsg={
          lang ? localeRu.deleteConfirmTitle : localeEn.deleteConfirmTitle
        }
        textQuestions={
          lang ? localeRu.deleteConfirmText : localeEn.deleteConfirmText
        }
        yes={lang ? "Да" : "Yes"}
        no={lang ? "Нет" : "No"}
      />
    </div>
  );
};

export default StationSettings;
